"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const throttler = require("@tanstack/pacer/throttler");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useThrottler(fn, options, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().throttler,
    ...options
  };
  const [throttler$1] = react.useState(() => new throttler.Throttler(fn, mergedOptions));
  throttler$1.fn = fn;
  throttler$1.setOptions(mergedOptions);
  const state = reactStore.useStore(throttler$1.store, selector);
  react.useEffect(() => {
    return () => {
      throttler$1.cancel();
    };
  }, [throttler$1]);
  return react.useMemo(
    () => ({
      ...throttler$1,
      state
    }),
    // omit `store` in favor of `state`
    [throttler$1, state]
  );
}
exports.useThrottler = useThrottler;
//# sourceMappingURL=useThrottler.cjs.map
